import { none, Option, some } from 'widgets-for-react'

export type PlyrSource = {
  type: string;
  sources: {
    src: string;
    provider: string;
  }[];
}

export const parseMediaVideoFile = (url: string): Option<PlyrSource> => {
  function getQueryVariable(variable: any, url: URL) {
    try {
      const query = url.search.substring(1);
      const vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === variable) {
          return decodeURIComponent(pair[1]);
        }
      }
      //console.log('Video query variable %s not found', variable);
    }
    catch (e) { }
    return undefined
  }

  let res: Option<PlyrSource> = none()
  
  try {
    const url1 = new URL(url)
    // Support `youtube` and `youtu.be`
    if (url1.hostname.toLowerCase().includes("youtu")) {
      let id = getQueryVariable('v', url1)
      if (id == undefined) {
        id = url1.pathname.substr(1)
      }
      res = some({
        type: "video",
        sources: [
          {
            src: id,
            provider: "youtube"
          }
        ]
      })
    }
    if (url1.hostname.toLowerCase().includes("vimeo")) {
      let id = url1.pathname.substr(1)
      res = some({
        type: "video",
        sources: [
          {
            src: url1.href,
            provider: "vimeo"
          }
        ]
      })
    }
  } catch (e) { }
  return res
}

export const videoUrl = (url: string) => parseMediaVideoFile(url)
